import { Box, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { useProviderAvatarStyles } from './styles';

export type MatchingAvatarProps = {
  avatarUrl?: string;
  nextAvailableDate?: string;
};

export const MatchingAvatar: React.VFC<MatchingAvatarProps> = props => {
  const { classes } = useProviderAvatarStyles();
  const l10n = useL10n();

  return (
    <Box className={classes.root}>
      <img src={props.avatarUrl} alt="avatar" className={classes.image} />
      <Box className={classes.nextAvailable}>
        <Typography variant="caption" color="textSecondary">
          {l10n.matching.providers.nextAvailable}
        </Typography>
        <Box className={classes.date}>
          {props.nextAvailableDate}
        </Box>
      </Box>
    </Box>
  );
};
